import request from '@/utils/request'

const url = '/home/payaliwx/'
const api = {
  toAlipay (data) {
    return request({
      url: url + 'toAlipay',
      method: 'post',
      data
    })
  },
  getOnlyOrder (data) {
    return request({
      url: url + 'getOnlyOrder',
      method: 'post',
      data
    })
  },
  gePayType (data) {
    return request({
      url: url + 'gePayType',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/pay.js